"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSheetAssociationForIssue = void 0;
var _documentHooks = require("../../../../utils/hooks/documentHooks");
var _hooks = require("../../../../state/redux/hooks");
var _sheets = require("../../../../state/redux/ducks/sheets");
var _documents = require("../../../../state/redux/ducks/documents");
const useSheetAssociationForIssue = _ref => {
  let {
    issue
  } = _ref;
  const documentUrn = (0, _documentHooks.getDocumentUrnOfIssue)(issue);
  const getDocument = (0, _documentHooks.useGetDocumentByDocumentUrn)();
  const documentRetrievedByUrn = getDocument(documentUrn);

  // the sheet association may associate with a sheet or a document version
  const sheetAssociation = (0, _hooks.useSelector)(_sheets.getSheetAssociationByIssueId)(issue === null || issue === void 0 ? void 0 : issue.id);

  // maybe it's referring to a sheet?
  const selectSheet = (0, _hooks.useSelector)(_sheets.getSheetBySheetId);
  let sheetId = undefined;
  if (sheetAssociation && sheetAssociation.surfaceType === _sheets.SHEET_SURFACE_TYPE) {
    sheetId = sheetAssociation.sheetId;
  }
  const sheet = selectSheet(sheetId);

  // or maybe it's referring to a document version
  const selectDocumentByVersion = (0, _hooks.useSelector)(_documents.getDocumentByDocumentVersionId);
  let documentVersionId = undefined;
  if (sheetAssociation && sheetAssociation.surfaceType === _sheets.DOCUMENT_SURFACE_TYPE) {
    documentVersionId = sheetAssociation.documentVersionId;
  }
  const documentRetrievedByVersionId = selectDocumentByVersion(documentVersionId);

  // the interface for `document` is used the same whether it is the full document retrieved by the URN
  // or just a single version of the document retrieved by ID
  const document = documentRetrievedByUrn || documentRetrievedByVersionId;
  return {
    sheet,
    document,
    sheetAssociation
  };
};
exports.useSheetAssociationForIssue = useSheetAssociationForIssue;
//# sourceMappingURL=useSheetAssociationForIssue.js.map